import { literal, struct, union } from 'io-ts/Decoder';

export const Request = struct({
	layout: union(literal('portrait'), literal('landscape')),
});
